document.addEventListener("click", function (e) {

  // MAIN FAQ TOGGLE
  const mainToggle = e.target.closest(".faq-main-toggle");
  if (mainToggle) {
    const main = mainToggle.closest(".faq-main");
    main.classList.toggle("active");
  }

  // QUESTION TOGGLE
  const questionBtn = e.target.closest(".faq-question");
  if (questionBtn) {
    const item = questionBtn.closest(".faq-item");
    const allItems = item.closest(".faq-list").querySelectorAll(".faq-item");

    allItems.forEach(i => {
      if (i !== item) i.classList.remove("active");
    });

    item.classList.toggle("active");
  }

});